import {
  DialogActions,
  FormControl,
  FormGroup,
  InputLabel,
  Select,
} from "@material-ui/core";
import { Dialog, MenuItem, TextField } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import DateFnsUtils from "@date-io/date-fns";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import React from "react";
import closeLogo from "../../assets/img/closeIcon.svg";
import { useState } from "react";
import { useEffect } from "react";

function CreationPopup(props) {
  const [selectedClass, setSelectedClass] = useState(
    props.classes && props.classes.length ? props.classes[0].id : "",
  );
  const [subject, setSubject] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [link, setLink] = useState("");
  const [start, setStart] = useState(props.startDate || moment().toDate());
  const [end, setEnd] = useState(
    props.endDate || moment().add(30, "minutes").toDate(),
  );
  const [type, setType] = useState("LIVE_CLASS");
  const [ocurrence, setOcurrence] = useState("NO");
  const [update, setUpdate] = useState(false);
  const [scheduleId, setScheduleId] = useState("");

  useEffect(() => {
    setSelectedClass(props.classes.length ? props.classes[0].id : "");
  }, [props.classes]);

  useEffect(() => {
    setStart(props.startDate);
    setEnd(props.endDate);
  }, [props.startDate, props.endDate]);

  useEffect(() => {
    if (props.editPopup && props.editDoc) {
      setUpdate(props.editPopup);
      setScheduleId(props.editDoc.id);
      setSelectedClass(props.editDoc.calendarId);
      setSubject(props.editDoc.title);
      setDescription(props.editDoc.body);
      setLink(props.editDoc.url);
      setStart(props.editDoc.start);
      setEnd(props.editDoc.end);
      setType(props.editDoc.customCategory);
      setOcurrence(props.editDoc.ocurrence);
    }
  }, [props.editPopup, props.editDoc]);

  useEffect(() => {
    if (!props.showCreationPopup) {
      setSubject("");
      setSubjectError("");
      setDescription("");
      setDescriptionError("");
      setLink("");
      setScheduleId("");
      setType("LIVE_CLASS");
      setStart(moment().toDate());
      setEnd(moment().add(30, "minutes").toDate());
      setOcurrence("NO");
    }
  }, [props.showCreationPopup]);

  return (
    <MuiThemeProvider>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        className="overlay"
        open={props.showCreationPopup}
        onClose={() => {
          setSubject("");
          setSubjectError("");
          setDescription("");
          setDescriptionError("");
          setLink("");
          setScheduleId("");
          setType("LIVE_CLASS");
          setStart(moment().toDate());
          setEnd(moment().add(30, "minutes").toDate());
          setOcurrence("NO");
          props.closeCreationPopup();
        }}
      >
        <div className="modal-card">
          <div className="modal-title">
            <b>{"Create Schedule"}</b>
          </div>

          <FormControl variant="outlined">
            <InputLabel>Class</InputLabel>
            <Select
              value={
                selectedClass ||
                (props.classes && props.classes.length
                  ? props.classes[0].id
                  : selectedClass)
              }
              onChange={(e) => setSelectedClass(e.target.value)}
              MenuProps={{ style: { zIndex: "99999999" } }}
              label="Class"
            >
              {props.classes.map((eachClass) => {
                return (
                  <MenuItem value={eachClass.id}>{eachClass.name}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            label="Subject"
            variant="outlined"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            onBlur={() => {
              if (!subject) {
                setSubjectError("Subject cannot be empty.");
              } else setSubjectError("");
            }}
            error={Boolean(subjectError)}
            helperText={subjectError}
          />
          <TextField
            label="Description"
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={() => {
              if (!description) {
                setDescriptionError("Description cannot be empty.");
              } else setDescriptionError("");
            }}
            error={Boolean(descriptionError)}
            helperText={descriptionError}
          />
          <TextField
            label="Link (optional)"
            variant="outlined"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "48% 48%",
              justifyContent: "space-between",
            }}
          >
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                renderInput={(props) => <TextField {...props} />}
                label="Start Date"
                value={start || props.startDate || new Date()}
                onChange={setStart}
                inputVariant="outlined"
                format="MMMM Do hh:mm A"
              />
            </MuiPickersUtilsProvider>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                renderInput={(props) => (
                  <TextField {...props} variant="outlined" />
                )}
                label="End Date"
                value={end || props.endDate || new Date()}
                onChange={setEnd}
                inputVariant="outlined"
                format="MMMM Do hh:mm A"
              />
            </MuiPickersUtilsProvider>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "48% 48%",
              justifyContent: "space-between",
            }}
          >
            <FormControl variant="outlined">
              <InputLabel>Category</InputLabel>
              <Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                MenuProps={{ style: { zIndex: "99999999" } }}
                label="Category"
              >
                <MenuItem value={"LIVE_CLASS"}>Live Class</MenuItem>
                <MenuItem value={"OTHERS"}>Others</MenuItem>
              </Select>
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel>Ocurrence</InputLabel>
              <Select
                value={ocurrence}
                onChange={(e) => setOcurrence(e.target.value)}
                MenuProps={{ style: { zIndex: "99999999" } }}
                label="Ocurrence"
              >
                <MenuItem value={"NO"}>Does not repeat</MenuItem>
                <MenuItem value={"WEEKDAY"}>Every Weekday</MenuItem>
                <MenuItem value={"DAILY"}>Daily</MenuItem>
                <MenuItem value={"WEEKLY"}>Weekly</MenuItem>
                <MenuItem value={"MONTHLY"}>Monthly</MenuItem>
                <MenuItem value={"YEARLY"}>Yearly</MenuItem>
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <button
              className="btn-button-blank"
              onClick={props.closeCreationPopup}
            >
              {"Cancel"}
            </button>
            <button
              className="btn-button"
              onClick={async () => {
                if (update) {
                  await props.updateSchedule({
                    id: scheduleId,
                    classId: selectedClass,
                    title: subject,
                    location: description,
                    start: start,
                    end: end,
                    url: link,
                    category: type,
                    ocurrence: ocurrence,
                  });
                  setScheduleId("");
                  setSubject("");
                  setDescription("");
                  setDescription("");
                  setLink("");
                  setOcurrence("NO");
                } else
                  props.createSchedule({
                    calendarId: selectedClass,
                    title: subject,
                    location: description,
                    url: link,
                    start,
                    end,
                    category: type,
                    ocurrence: ocurrence,
                  });
              }}
              disabled={Boolean(subjectError) || Boolean(descriptionError)}
            >
              {"Save"}
            </button>
          </DialogActions>
        </div>
      </Dialog>
    </MuiThemeProvider>
  );
}

export default CreationPopup;
